module.exports = __webpack_public_path__ + "static/media/Spin.8d7a5df7.png";